import { ReactComponent as AddOutline } from '@basqet-dashboard/common/assets/icons/add-outline.svg';
import { Button } from '@basqet-dashboard/common/components';
import { APP_NAME } from '@basqet-dashboard/common/config';
import { useSessionStorage } from '@basqet-dashboard/common/hooks';
import { useNavigateTo } from '@basqet-dashboard/common/utils';
import PropTypes from 'prop-types';
import React from 'react';

import { PAYOUT_ACTION_ITEMS } from '../../../config';

const PayoutActions = ({ setSelectedModal }) => {
  const { navigateTo } = useNavigateTo();

  const [token] = useSessionStorage(APP_NAME, '');
  const { TwoFaEnabled } = token;
  return (
    <div className="card payout__actions">
      <h3 className="card__title">
        Payout <span className="text-cursive">Actions</span>
      </h3>
      <ul className="payout__actions__list">
        {PAYOUT_ACTION_ITEMS.map((payoutAction, index) => {
          const { label, path, modal, icon, disabled } = payoutAction;

          const handleClick = () => {
            if (modal) {
              setSelectedModal(() => (TwoFaEnabled ? modal : 'WARN_ABOUT_2FA'));
            }

            if (path) {
              navigateTo(path);
            }
          };
          return (
            <li key={`payout_action-${index}`}>
              <Button onClick={handleClick} variant="outline" disabled={disabled}>
                {icon}
                <span>{label}</span>
              </Button>
            </li>
          );
        })}
      </ul>
      <Button
        size="large"
        variant="dashed"
        isFull
        onClick={() => navigateTo('/settings/beneficiary')}>
        <AddOutline />
        Add Beneficiaries
      </Button>
    </div>
  );
};

PayoutActions.propTypes = {
  setSelectedModal: PropTypes.func
};

export { PayoutActions };
